import AOS from 'aos';
import _, { debounce } from 'underscore'; //https://underscorejs.org/#debounce
import 'slick-carousel/slick/slick.min.js'; // using min version as unmin version has a bug
import inView from 'in-view';
import Modal from 'bootstrap/js/dist/modal';

// custom jquery below
jQuery(document).ready(function ($) {
    'use strict';

    // FADE IN CONTENT ON PAGE LOAD
    setTimeout(function () {
        $('body').addClass('delayfade');
    }, 200);

    // animate on scroll init - https://michalsnik.github.io/aos/
    AOS.init({
        offset: 200
    });

    // Prevent text widows on targetted elements
    //https://matmartin.co.uk/blog/code-prevent-widows-and-orphans-web-layouts/
    $('.no-orphans, .no-child-orphans p').each(function() {
        let string = $(this).html();
        string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
        $(this).html(string);
    });



    /*****************************************************
    **************** MENU FUNCTIONALITY ******************
    *****************************************************/
    let navState = 'desktop';
    let navTimer = 500;
    let mobileBreakpoint = 767;
    const $body = $('body');
    const $mToggle = $('header #responsive-toggle');
    const $mNavWrap = $('header .main-navigation.mobile');
    const $subToggles = $('header .main-navigation.mobile .has-subnav');
    const $subToggleSpan = $('header .main-navigation.mobile .has-subnav span');


    // SET NAVSATE / INIT
    const setNavState = function() {

        if( $(window).width() > mobileBreakpoint ) {

            navState = 'desktop';
            $body.removeClass('mobile-nav-open');
            $mToggle.removeClass('open');
            $mNavWrap.removeClass('open');
            $subToggles.removeClass('open');

        } else {

            navState = 'mobile';

        }
    }

    // Mobile nav toggle
    $mToggle.click(function() {

        if( !$mToggle.hasClass('open') ) {

            $body.addClass('mobile-nav-open');
            $mToggle.addClass('open');
            $mNavWrap.addClass('open');

        } else {

            $body.removeClass('mobile-nav-open');
            $mToggle.removeClass('open');
            $mNavWrap.removeClass('open');
            $subToggles.removeClass('open');

        }

    });

    // Subnav toggles
    $subToggleSpan.click(function(e) {
        const $curr = $(e.currentTarget);

        if( !$curr.parent().hasClass('open') ) {

            $subToggles.removeClass('open');
            $curr.parent().addClass('open');

        } else {

            $curr.parent().removeClass('open');

        }

    });

    setNavState();

    $(window).resize(
        _.debounce(setNavState, 300)
    );
    /*********************** END MENU FUNCTIONALITY ***********************/



    /**********************************************************
    ************************* SLIDERS *************************
    **********************************************************/

    // REFERENCE SLICK SLIDER DOCS - https://kenwheeler.github.io/slick/

    let $hrlSlider = $('.content-slider-block');

    if( $hrlSlider.length ) {

        $hrlSlider.each(function() {

            // TESTIMONIAL SLIDER
            if( $(this).hasClass('style-slider-testimonials') ) {

                let hrlAppendDots = $(this).find('.slider-wrap .dots-nav');
                let hrlCustomPagingFunction = function() {
                    return $('<span></span>');
                };

                $(this).find('.hrl-slider-init').slick({
                    arrows: false,
                    autoplay: false,
                    dots: true,
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    appendDots: hrlAppendDots,
                    customPaging: hrlCustomPagingFunction,
                    responsive: [
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });
            }

            // VIDEO SLIDER
            if( $(this).hasClass('style-slider-videos') ) {
                let hrlMainSlider = $(this).find('.hrl-slider-init.main-video-viewer');
                let hrlThumbSlider = $(this).find('.hrl-slider-init.thumbs');
                let hrlThumbSlide = $(hrlThumbSlider).find('.hrl-slide');
                let iframes = hrlMainSlider.find('iframe');

                // POST commands to YouTube or Vimeo API
                function postMessageToPlayer(player, command){
                    if (player == null || command == null) return;
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }

                function playPauseVideo(slick, control){
                    var currentSlide, slideType, startTime, player, video;

                    currentSlide = slick.find(".slick-current");
                    player = currentSlide.find("iframe").get(0);
                    startTime = currentSlide.data("video-start");

                    switch (control) {
                        case "play":
                            if ( (startTime != null && startTime > 0 ) && !currentSlide.hasClass('started') ) {
                                currentSlide.addClass('started');
                                postMessageToPlayer(player, {
                                    "method": "setCurrentTime",
                                    "value" : startTime
                                });
                            }
                            postMessageToPlayer(player, {
                                "method": "play",
                                "value" : 1
                            });
                        break;

                        case "pause":
                            postMessageToPlayer(player, {
                                "method": "pause",
                                "value": 1
                            });
                        break;

                    }
                }

                hrlMainSlider.on("init", function(slick){
                    slick = $(slick.currentTarget);
                        setTimeout(function(){
                        playPauseVideo(slick,"play");
                    }, 1000);
                });
                hrlMainSlider.on("beforeChange", function(event, slick) {
                    slick = $(slick.$slider);
                    playPauseVideo(slick,"pause");
                });
                hrlMainSlider.on("afterChange", function(event, slick) {
                    slick = $(slick.$slider);
                    playPauseVideo(slick,"play");
                });

                hrlMainSlider.slick({
                    arrows: false,
                    autoplay: false,
                    dots: false,
                    infinite: false,
                    fade: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                });

                hrlThumbSlider.slick({
                    arrows: true,
                    autoplay: false,
                    dots: false,
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    lazyLoad:"progressive",
                    centerPadding: '40px',
                    prevArrow: '<span class="prev"><i class="fa-regular fa-angle-left"></i></span>',
                    nextArrow: '<span class="next"><i class="fa-regular fa-angle-right"></i></span>',
                    responsive: [
                        {
                            breakpoint: 921,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });

                $(hrlThumbSlide).each(function(e, i) {
                    $(this).click(function(e) {
                        e.preventDefault();
                        let currentIndex = $(this).index();
                        $(hrlThumbSlide).removeClass('active');
                        $(this).addClass('active');
                        $(hrlMainSlider).slick('slickGoTo', currentIndex);
                    });
                });

            }
        });

    }
    /*********************** END SLIDERS ***********************/

    /********** ODOMETER / TICKING FUNCTIONALITY FOR STATISTIC COLS **********/
    inView('.hrl-counter')
        .on('enter', function() {

            $('.counter-value').each(function() {

                $(this).html( $(this).data('count') );

            });

        })
        .on('exit', function() {

            $('.counter-value').each(function() {

                $(this).html( '0' );

            });

        });
    /*********************** END ODOMETER ***********************/

    // fix to stop videos playing in modal when modal closes
    // $('.cta-text-diag-modal').on('hidden.bs.modal', function (e) {

    //     const currItem = e.currentTarget;
    //     let videoSrc = $('.cta-text-diag-modal iframe').attr('src');

    //     $(currItem).find('iframe').attr('src', videoSrc);

    //     console.log(videoSrc);
    //     // console.log($curr);

    //     // $curr.data('src', '');

    //     // $('.cta-text-diag-modal iframe').data('src', $('.cta-text-diag-modal iframe').data('src'));
    // });

    // $('.modal-closer').click(function(e) {
    //     e.preventDefault();
    //     console.log($(".cta-text-diag-modal iframe").data("src"));
    // })



    $('.cta-text-diag-modal').on('hidden.bs.modal', function(e) {

        var player = $('.cta-text-diag-modal').find('iframe').get(0);

        function postMessageToPlayer(player, command){
            if (player == null || command == null) return;
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }

        postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
        });
    })

});

